import { useEffect, useMemo, useState } from 'react'
import { EmphasizeMessage } from '../globals'
import { getRandomizeMessage } from '../utils'

type ChatEmphasizerProps = {
  messages: EmphasizeMessage[]
  display: 'atScroll' | number
  disappear: 'atScroll' | number
  chatUiOpen: boolean
  locale: string
}

const ChatEmphasizer = ({
  messages = [],
  display = 1000,
  disappear = 4000,
  chatUiOpen,
  locale = 'sv_SE'
}: Partial<ChatEmphasizerProps>) => {
  const [open, setOpen] = useState(false)
  const message = useMemo(() => getRandomizeMessage(messages), [])

  const onCloseHandler = () => {
    setOpen(false)
  }

  const openEmphasizer = () => {
    setOpen(true)
  }

  useEffect(() => {
    if (chatUiOpen) {
      setOpen(false)
    }
  }, [chatUiOpen])

  useEffect(() => {
    if (display === 'atScroll' && !open) {
      document.addEventListener('scroll', openEmphasizer)

      return () => {
        document.removeEventListener('scroll', openEmphasizer)
      }
    }

    if (typeof display === 'number') {
      setTimeout(() => {
        openEmphasizer()
      }, display)
    }
  }, [])

  useEffect(() => {
    if (disappear === 'atScroll') {
      document.addEventListener('scroll', onCloseHandler)

      return () => {
        document.removeEventListener('scroll', onCloseHandler)
      }
    }

    if (typeof disappear === 'number' && open) {
      setTimeout(() => {
        onCloseHandler()
      }, disappear)
    }
  }, [open])

  const tmpLocale = locale?.length?locale:"sv_SE";
  return (
    <div
      id="chatEmphasizer"
      className={open ? 'chatEmphasizerVisible' : 'hidden'}
    >
      <button className="close-chat-emphasizer" onClick={onCloseHandler} />
      <p className="chat-emphasizer-content">{message[tmpLocale ]}</p>
      <div className="chat-emphasizer-arrow"></div>
    </div>
  )
}

export default ChatEmphasizer
